import { Colors } from "@jsq/ds/styles";
import { AnnouncementStatus } from "../types";
import { StatusDetails } from "./types";

export const invalidStatusDetail: StatusDetails = {
  displayText: "Invalid status",
  iconColor: Colors.Danger600,
};

const statusMap = new Map<string, StatusDetails>([
  [
    "Active",
    {
      displayText: "Active",
      iconType: "circle",
      iconColor: Colors.Success200,
    },
  ],
  [
    "Inactive",
    {
      displayText: "Inactive",
      iconType: "circle",
      iconColor: Colors.Neutral400,
    },
  ],
  [
    "Deleted",
    {
      displayText: "Deleted",
      iconType: "circle",
      iconColor: Colors.Danger600,
    },
  ],
  ["Invalid", invalidStatusDetail],
]);

/**
 * Maps an announcement status to its corresponding display text, icon type, and icon color.
 *
 * @param {AnnouncementStatus} status - The status of the announcement.
 * @returns {StatusDetails | undefined} The details for the given status, or undefined if the status is not found.
 */
export const mapStatusToText = (status: AnnouncementStatus): StatusDetails => {
  return statusMap.get(status) ?? invalidStatusDetail;
};
